module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    ref: "carousel",
    staticClass: "owl-banner owl-carousel owl-theme"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), _c('div', {
    staticClass: "home2"
  }, [_c('div', {
    staticClass: "w-wrap xr-now xr-act"
  }, [_c('div', {
    staticClass: "unit xr-cur"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('div', {
    staticClass: "t_title"
  }, [_vm._v("News")]), _vm._v(" "), _c('div', {
    staticClass: "pad"
  }, [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_c('a', {
    staticClass: "t_more b red"
  }, [_vm._v("more")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "home2-content"
  }, [_c('div', {
    staticClass: "home2-content-box"
  }, [_c('div', {
    staticClass: "home2-content-box-line",
    attrs: {
      "id": "home2-line"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home2-content-box-item home2-content-box-top wow slideInLeft",
    on: {
      "click": function($event) {
        return _vm.goTo('1')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "home2-content-box-item home2-content-box-bot wow slideInRight",
    on: {
      "click": function($event) {
        return _vm.goTo('2')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "home2-more-box wow bounceInUp",
    attrs: {
      "data-wow-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "home2-more-box-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/blog"
    }
  }, [_c('a', {
    staticClass: "home2-more-box-content-top t_more"
  }, [_vm._v("More")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "home2-content-mobile"
  }, [_c('div', {
    staticClass: "ul",
    staticStyle: {
      "min-width": "10px",
      "min-height": "10px"
    }
  }, [_c('div', {
    staticClass: "li li1"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('1')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "li li2"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('2')
      }
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "home5"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('div', {
    staticClass: "t_title"
  }, [_vm._v("Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "pad"
  }, [_c('a', {
    staticClass: "t_more b red",
    staticStyle: {
      "cursor": "pointer",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.router('/PricingPlan')
      }
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('div', {
    staticClass: "slick-nav"
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "slick-snav"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/banner4.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/banner3.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/banner5.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/banner7.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/banner8.JPG"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home2-content-box-item-lf"
  }, [_c('div', {
    staticClass: "home2-content-box-item-lf-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/home/news.png",
      "alt": "feature"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home2-content-box-item-rt"
  }, [_c('div', {
    staticClass: "home2-content-box-item-text"
  }, [_c('h4', [_vm._v("\n                        The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December 24, 2023.\n\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home2-content-box-item-lf"
  }, [_c('div', {
    staticClass: "home2-content-box-item-text"
  }, [_c('h4', [_vm._v("The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in the digital age.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home2-content-box-item-rt"
  }, [_c('div', {
    staticClass: "home2-content-box-item-rt-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/home/news1.png",
      "alt": "feature"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "i",
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/home/news.png",
      "alt": "",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "t"
  }, [_c('h4', [_vm._v("\n                          The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December 24, 2023.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "i",
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/home/news1.png",
      "alt": "",
      "title": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "t"
  }, [_c('h4', [_vm._v("The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in the digital age.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slick-big-box",
    staticStyle: {
      "min-width": "10px",
      "min-height": "10px"
    }
  }, [_c('div', {
    staticClass: "slick-mod"
  }, [_c('div', {
    staticClass: "employee-slider owl-carousel owl-theme"
  }, [_c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/3.jpg",
      "alt": "employee"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/6.png",
      "alt": "employee"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/10.jpg",
      "alt": "employee"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/11.jpg",
      "alt": "employee"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/12.jpg",
      "alt": "employee"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-slide"
  }, [_c('div', {
    staticClass: "slide-img"
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/Gallery/13.jpg",
      "alt": "employee"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dcde9a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 74
// module chunks = 0